import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import axios from 'axios';

@Component
class SettingsChildNotification extends Vue {

  snack = false;
  snackColor = '';
  snackText = '';
  max50chars = v => v.length <= 50 || 'Input too long!';
  pagination = {};
  headers = [
    {
      text: 'Name',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    { text: 'Description', value: 'description' },
    { text: 'Type', align: 'center', value: 'type' },
    { text: 'Sub type', align: 'center', value: 'sub_type' },
    //{ text: 'created at', value: 'protein' },
    //{ text: 'updated at', value: 'iron' }
  ];
  notifications: any = [];

  constructor() {
    super()
  }

  created() {
    this.getNotifications();
  }

  async getNotifications() {
    let response = await axios.get('/notification_type');
    if (response.data) {
      this.notifications = response.data.data
    }
  }

  async saveNotification(notificationType) {
    let params = {
      name: notificationType.name,
      description: notificationType.description
    }
    axios.patch('/notification_type/' + notificationType.id, params)
      .then(response => {
        console.log('response saved', response)
        this.snackbar(response.status+' Data saved', 'success')
      })
      .catch(error => {
        this.snackbar(error.status+' error', 'error')
      })
  }

  snackbar(text, color) {
    this.snack = true
    this.snackColor = color
    this.snackText = text
  }

  save(value) {
    console.log(value)
    this.saveNotification(value)
  }

  cancel() {
    this.snack = true
    this.snackColor = 'error'
    this.snackText = 'Canceled'
  }

  open() {
    //this.snack = true
    //this.snackColor = 'info'
    //this.snackText = 'Dialog opened'
  }

  close() {
    console.log('Dialog closed')
  }
}

export default SettingsChildNotification;



// WEBPACK FOOTER //
// ./src/containers/settings/settings-child-notification/index.ts